import React from "react";

const StaffMemberCard = (props) => {
    return (
        <div className="card computer border-0 product-item item" key={props.staffMember.id}>
            <img className="card-img-top border-bottom" src={'/assets/images/staff/' + props.staffMember.imgLink} alt="" />
            <div className="card-body">
                <div className="d-flex align-items-center justify-content-between">
                    <small className="text-uppercase font-w-600">{props.staffMember.title}</small>
                </div>
                <h5 className="text-dark font-w-600 mt-10 mb-10">{props.staffMember.name}</h5>
            </div>
        </div>
    )
}

export default StaffMemberCard;
